import { Component, EventEmitter, inject, Output } from '@angular/core';
import { DateFilterComponent, AccountFilterComponent } from '../../../../_shared/components';
import { DriverFilterComponent } from '../../../../_shared/components/filters/driver-filter/driver-filter.component';
import { AccountFilterData, DriverFilterData, DateIntervalFilterData, WidgetFilterData } from '../../../../_shared/models';
import { isEmptyObject } from '../../../../_shared/helpers/object.helper';
import { Observable, Subject } from 'rxjs';
import { FilterService } from '../../../../_shared/services';

@Component({
  selector: 'app-executive-stats-filter',
  standalone: true,
  imports: [
    DateFilterComponent,
    AccountFilterComponent,
    DriverFilterComponent
  ],
  templateUrl: './executive-stats-filter.component.html',
  styleUrl: './executive-stats-filter.component.scss'
})
export class ExecutiveStatsFilterComponent {
  @Output() dateFilterChange = new EventEmitter<DateIntervalFilterData>();

  private filterService = inject(FilterService);

  dateFilter: DateIntervalFilterData;
  accountFilter: AccountFilterData;
  driverFilter: DriverFilterData;
  accountFilterChangedSubject: Subject<number[]> = new Subject<number[]>();
  accountFilterChanged$: Observable<number[]> = this.accountFilterChangedSubject.asObservable();

  constructor() {
    this.dateFilter = {} as DateIntervalFilterData;
    this.accountFilter = {} as AccountFilterData;
    this.driverFilter = {} as DriverFilterData;
  }

  onAccountFilterChange(filter: AccountFilterData) {
    if (!isEmptyObject(filter)) {
      this.accountFilter = filter;
      this.accountFilterChangedSubject.next(filter.accountIds);
      this.updateFilter();
    }
  }

  onDateFilterChange(filter: DateIntervalFilterData): void {
    if (!isEmptyObject(filter)) {
      this.dateFilter = filter;
      this.dateFilterChange.emit(this.dateFilter);
      this.updateFilter();
    }
  }

  onDriverFilterChange(filter: DriverFilterData): void {
    if (!isEmptyObject(filter)) {
      this.driverFilter = filter;
      this.updateFilter();
    }
  }

  updateFilter(): void {
    if (!isEmptyObject(this.accountFilter) && !isEmptyObject(this.driverFilter) && !isEmptyObject(this.dateFilter)) {
      this.filterService.updateFilter({
        ...this.accountFilter,
        ...this.dateFilter,
        ...this.driverFilter
      } as WidgetFilterData);
    }
  }
}